<template>
    <div class="tournament-info">
      <div class="app-container">
        <div class="row">
          <h2 class="section-title">Informasi Kegiatan</h2>  
          <div class="col-md-3 mb-4">
            <div class="tournament-info-item">
              
              <div class="tournament-info-item-content">
                <h5>Lokasi</h5>
                <p v-html="tournament.location"> 
                </p>
                
              </div>
            </div>
          </div>
  
          <!-- Gallery Item 2 -->
          <div class="col-md-3 mb-4">
            <div class="tournament-info-item">
              
              <div class="tournament-info-item-content">
                <h5>Tanggal Pertandingan</h5>
                <p>{{ tournament.event_date }}</p>
                
              </div>
            </div>
          </div>
  
          <!-- Gallery Item 3 -->
          <div class="col-md-3 mb-4">
            <div class="tournament-info-item">
              
              <div class="tournament-info-item-content">
                <h5>Kategori</h5>
                <ul>
                  <li v-for="(matchCategory, index) in tournament.matchCategories" :key="index">
                    {{ matchCategory.name }}
                  </li>
                  
                </ul>
                
              </div>
            </div>
          </div>

          <!-- Gallery Item 4 -->
          <div class="col-md-3 mb-4">
            <div class="tournament-info-item">
              
              <div class="tournament-info-item-content">
                <h5>Usia</h5>
                <ul>
                  <li v-for="(ageCategory, index) in tournament.ageCategories" :key="index">
                    {{ ageCategory.name }}
                  </li>
                </ul>
                
              </div>
            </div>
          </div>
        </div>
        <!--
          Baris "Biaya Pendaftaran" dan "Contact Person" DIHAPUS dari sini.

          Keduanya kembar dengan seksi Biaya Pendaftaran dan Hubungi Panitia
          di halaman detail, jadi pengunjung melihat dua daftar biaya dalam
          satu halaman.

          Versi di sini juga versi yang salah: nominalnya dicetak mentah
          ("250000.00", tanpa Rp maupun pemisah ribuan), dan datanya dibaca
          dari tournament.matchCategories serta tournament.contactPersons —
          nama camelCase yang tidak pernah dikirim API. Yang dikirim adalah
          categories dan contact_persons, sehingga kedua daftar itu memang
          selalu kosong.
        -->
      </div>
    </div>
</template>
  
  <script>
  export default {
    name: 'TournamentInfo',
    props: {
      tournament: {
        type: Object,
        required: true,
      },
    },
  };
  </script>

<style scoped>
/*
 * Warna di berkas ini dulu dipaku (#181818, #000, #fff, dst), sehingga
 * bagian halaman ini TETAP GELAP walau pengguna memilih tema terang —
 * dan tetap terang di bagian lain, jadi satu halaman terlihat separuh
 * gelap separuh terang. Sekarang semuanya membaca variabel tema, jadi
 * ikut berganti bersama sisa situs.
 */

.tournament-info{
    background-color: var(--bg-base);
    padding-bottom: 20px;
}








.section-title {
    text-align: start;
    font-size: clamp(1.3rem, 5vw, 2rem);
    font-family: var(--font-display);
    margin-bottom: 20px;
    color: var(--text-primary);
}

.sub-section-title {
    text-align: center;
    font-size: clamp(1.1rem, 4vw, 1.4rem);
    font-family: var(--font-display);
    margin-bottom: 16px;
    color: var(--text-primary);
}


.tournament-info-item {
  position: relative;
  background-color: var(--bg-surface);
  overflow: hidden;
  min-height: auto;
  border-radius: 8px;
  border-top: 2px solid var(--danger-600);
}

.tournament-info-item img {
  width: 100%;
  height: auto;
}

.tournament-info-item-content {
  padding: 12px;
  background-color: var(--bg-surface); 
  /*
   * Teks di atas permukaan HARUS memakai --text-primary, bukan
   * --text-inverse. Nilai aslinya dulu 'white', dan penggantian massal
   * memetakannya ke --text-inverse tanpa melihat latarnya: di mode terang
   * itu berarti putih di atas permukaan putih — tulisannya hilang sama
   * sekali. --text-inverse hanya benar di atas warna pekat seperti tombol
   * merah di bawah.
   */
  color: var(--text-primary);
}

.tournament-info-item-content h5 {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 6px;
}

.tournament-info-item-content p {
  font-family: var(--font-sans);
  font-size: 0.85rem;
  margin-bottom: 10px;
}

.tournament-info-item-content ul {
  list-style-type: square;
  padding: 0;
  margin-left: 20px;
  font-family: var(--font-sans);
  font-size: 0.85rem;
}

.tournament-info-item-content .more-info {
  font-size: 1rem;
  padding: 10px 20px;
  background-color: var(--danger-600);
  color: var(--text-inverse, #fff);
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

.tournament-info-item-content .more-info:hover {
  background-color: var(--accent);
}

@media (max-width: 768px) {
  .tournament-info-item img {
    height: 100%;
  }

  .section-title {
    text-align: center;
  }
}
</style>